import { Button } from '@ordr-as/umami-react/button';
import SelectDigitalBill from './SelectDigitalBill';
import BackButton from '../../../../components/BackButton';
import { useCheckout } from '../../../../context/CheckoutContext';
import CashIcon from '@ordr-as/icons/CashIcon';
import TableServiceIcon from '@ordr-as/icons/TableServiceIcon';
import { useLocation } from '../../../../context/LocationContext';

const OpenBillPicker = () => {
  const { setSidebarContent } = useCheckout();
  const { location } = useLocation();
  const hasTableDeliveryMethod = location.deliveryMethods.some((deliveryMethod) => deliveryMethod.type === 'TABLE');

  return (
    <>
      <BackButton title="Select table" navigateTo={() => setSidebarContent('CART')} />
      <div className="p-4 pt-2">
        <div className="w-full flex-wrap p-2 tablet:p-4 justify-center flex gap-4">
          <Button
            className="flex flex-1 min-w-[170px] h-7 items-center gap-3"
            onClick={() => setSidebarContent('CREATE_TABLE')}
            kind="secondary"
            size="small"
          >
            <TableServiceIcon className="h-4 w-4" />
            <div className="text-left text-nowrap">
              <p className="text-sm">Open table</p>
              <p className="text-xs">Pay later</p>
            </div>
          </Button>
          {hasTableDeliveryMethod && (
            <Button
              onClick={() => setSidebarContent('SET_TABLE_NUMBER')}
              className="flex flex-1 min-w-[170px] h-7 items-center gap-3"
              kind="secondary"
              size="small"
            >
              <CashIcon className="h-4 w-4" />
              <div className="text-left text-nowrap">
                <p className="text-sm ">Table number</p>
                <p className="text-xs ">Pay now</p>
              </div>
            </Button>
          )}
        </div>
        <SelectDigitalBill onClose={() => setSidebarContent('CART')} />
      </div>
    </>
  );
};

export default OpenBillPicker;
